export const mealTypeFields = {
    id: 'id',
    name: 'name',
} as const;
